module.exports = __webpack_public_path__ + "static/media/icn-warn-yellow.785af3b7.svg";